module.exports = __webpack_public_path__ + "img/sp-step1.09a8ab87.png";